// src/components/footerConfigs.js
import praLogo from "../assets/pra_logo.jpg";
export const footerConfigs = {
  "bheema": {
    trust: "OM YUVAK GADINAD SHIKSHAN SAMSTHE(R) CHADCHAN",
    // Official School Name (Reports, Certificates, Website)
  brandName: "Shree S.S.H Internatinal English Medium School,Chadchan",
    // Short School Name (SMS)
    smsSchoolName: "S.S.H ENG MED School,Chadchan",
    // Domain only (optional)
    domain: "sshschool.in",
    // Address
    address:
  "Indi road Devar Nimbargi Cross(Hanuman Nagar),CHADCHAN-586205 Dist:Vijayapura",
    contact: "+91 9035393037,8867669037 | cdnshankar@gmail.com",
    logo: praLogo,
    // School-specific Google Map
    googleMap:
    "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3809.3872025339565!2d75.67939437516283!3d17.296857283575047!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTfCsDE3JzQ4LjciTiA3NcKwNDAnNTUuMSJF!5e0!3m2!1sen!2sin!4v1784024364333!5m2!1sen!2sin",
    affiliationNo:"12345",
    socialLinks: {
      instagram: "https://www.instagram.com/shree_ssh/",
      whatsapp:   "https://wa.me/yourwhatsapplink",
      youtube:    "https://www.youtube.com/",
      facebook:   "https://www.facebook.com/",
      twitter:    "https://twitter.com"
    }
  },
  "acmeCorp": {
    brandName: "ACME Corporation",
    contact: "1800-ACME | support@acme.com",
    socialLinks: {
      instagram: "https://instagram.com/acmecorp",
      whatsapp:   "",
      youtube:    "https://youtube.com/acmecorp",
      facebook:   "https://facebook.com/acmecorp",
      twitter:    "https://twitter.com/acmecorp"
    }
  }
  // add more customer configs here...
};
